import { format } from "date-fns";
import { enUS, type Locale as DateFnsLocale } from "date-fns/locale";
import { Locale } from "@/i18n";

const formatLocales: Record<Locale, DateFnsLocale> = {
  en: enUS,
};

type FormatParams = Parameters<typeof format>;
type Date = FormatParams[0];
type FormatString = FormatParams[1];
interface FormatOptionsWithRequiredLocale
  extends Omit<FormatParams[2], "locale"> {
  locale: Locale;
}

export const formatDate = (
  date: Date,
  formatStr: FormatString,
  options: FormatOptionsWithRequiredLocale,
) => {
  const { locale, ...rest } = options;
  return format(date, formatStr, { locale: formatLocales[locale], ...rest });
};
